(function($){

    $.fn.shuffle = function() {

        const allElems = this.get();
        const getRandom = function(max) {
            return Math.floor(Math.random() * max);
        };
        const shuffled = $.map(allElems, ()=> {
            const random = getRandom(allElems.length);
            const randEl = $(allElems[random]).clone(true)[0];
            allElems.splice(random, 1);
            return randEl;
        });

        this.each(function(i){
            $(this).replaceWith($(shuffled[i]));
        });

        return $(shuffled);

    };

})(jQuery);
